// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab {
    background-color: #999;
    background-image: linear-gradient(to bottom, #999, #999);
    color: #fff;
    cursor: pointer;
    display: inline-block;
    margin-bottom: 20px;
    padding: 15px 9px !important;
    position: relative;
}

.tab~.tab {
    margin-left: 5px;
}

.tab i {
    display: inline;
    background-image: none;
    font-size: 12px;
    line-height: 1.6;
}

.tab h3 {
    display: inline-block;
    margin: 0;
    font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
    font-size: 18px;
}

.tab.active {
    background-color: #e5e5e5;
    background-image: linear-gradient(to bottom, #e5e5e5, #fff);
    color: #000;
    cursor: default;
}

.tab .header {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 18px;
    font-family: "Avenir Next LT W01 Demi", Arial, serif;
    display: inline-block;
}

@media (max-width: 768px) {
    .expand-collapse {
        background-color: #999;
        background-image: linear-gradient(to bottom, #999, gray);
        color: #fff;
        cursor: pointer;
        margin-bottom: 1px;
        padding: 15px 9px;
        overflow: hidden;
    }

    .expand-collapse h3 {
        margin-bottom: 0;
        display: inline;
        color: #fff;
        font-family: "Avenir Next LT W01 Demi", Arial, serif;
        font-size: 18px;
        margin-top: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/tabs.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,wDAAwD;IACxD,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,yDAAyD;IACzD,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,2DAA2D;IAC3D,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,oDAAoD;IACpD,qBAAqB;AACzB;;AAEA;IACI;QACI,sBAAsB;QACtB,wDAAwD;QACxD,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,WAAW;QACX,oDAAoD;QACpD,eAAe;QACf,aAAa;IACjB;AACJ","sourcesContent":[".tab {\n    background-color: #999;\n    background-image: linear-gradient(to bottom, #999, #999);\n    color: #fff;\n    cursor: pointer;\n    display: inline-block;\n    margin-bottom: 20px;\n    padding: 15px 9px !important;\n    position: relative;\n}\n\n.tab~.tab {\n    margin-left: 5px;\n}\n\n.tab i {\n    display: inline;\n    background-image: none;\n    font-size: 12px;\n    line-height: 1.6;\n}\n\n.tab h3 {\n    display: inline-block;\n    margin: 0;\n    font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n    font-size: 18px;\n}\n\n.tab.active {\n    background-color: #e5e5e5;\n    background-image: linear-gradient(to bottom, #e5e5e5, #fff);\n    color: #000;\n    cursor: default;\n}\n\n.tab .header {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 18px;\n    font-family: \"Avenir Next LT W01 Demi\", Arial, serif;\n    display: inline-block;\n}\n\n@media (max-width: 768px) {\n    .expand-collapse {\n        background-color: #999;\n        background-image: linear-gradient(to bottom, #999, gray);\n        color: #fff;\n        cursor: pointer;\n        margin-bottom: 1px;\n        padding: 15px 9px;\n        overflow: hidden;\n    }\n\n    .expand-collapse h3 {\n        margin-bottom: 0;\n        display: inline;\n        color: #fff;\n        font-family: \"Avenir Next LT W01 Demi\", Arial, serif;\n        font-size: 18px;\n        margin-top: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
